import {
    GET_TIPOS_ARTICULO,
    ADD_TIPO_ARTICULO,
    MODIFY_TIPO_ARTICULO,
    DELETE_TIPO_ARTICULO,
    UPDATE_TIPOS_ARTICULO
} from '../constants/action_types';

const initialState = {
    tiposarticulo: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPOS_ARTICULO:

            return {
                tiposarticulo: [],
                isLoading: true
            };
        case GET_TIPOS_ARTICULO + "_SUCCESS":
        
            return {
                tiposarticulo: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_ARTICULO:

           const newArr = [...state.tiposarticulo, action.payload]
            return {
                tiposarticulo: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_ARTICULO:

            return {
                tiposarticulo: state.tiposarticulo.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };

        case DELETE_TIPO_ARTICULO:

            return {
                tiposarticulo: state.tiposarticulo.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPOS_ARTICULO + "_SUCCESS":

            return state;

        default:

            return state;
    }
}